import Cookies from 'js-cookie';
import apiClient from 'services/_infra/apiClient';
import { tryCache } from 'services/_infra/requestCache';

export async function getAirQualityObservation() {
  try {
    const res = await tryCache(
      `getAirQualityObservation-${Cookies.get('latitude')}-${Cookies.get('longitude')}`,
      () =>
        apiClient.post('/CWW_getAirQualityObservation', {
          city: Cookies.get('city'),
          state: Cookies.get('state'),
          longitude: Cookies.get('longitude'),
          latitude: Cookies.get('latitude'),
        }),
    );
    return res;
  } catch (error) {
    console.error('getAirQualityObservation failed.', error);
  }
}

export async function getAirQualityForecast() {
  try {
    const res = await tryCache(
      `getAirQualityForecast-${Cookies.get('latitude')}-${Cookies.get('longitude')}`,
      () =>
        apiClient.post('/CWW_getAirQualityForecast', {
          city: Cookies.get('city'),
          state: Cookies.get('state'),
          longitude: Cookies.get('longitude'),
          latitude: Cookies.get('latitude'),
        }),
    );
    return res;
  } catch (error) {
    console.error('getAirQualityForecast failed.', error);
  }
}
